import { Button, useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";

export type InspirationCtaVariant = "primary" | "secondary" | "tertiary";

export type InspirationCta = {
	label: string;
	icon?: LucideIcon;
	onClick: () => void;
	variant?: InspirationCtaVariant;
	disabled?: boolean;
};

type Props = {
	cta: InspirationCta;
};

export const InspirationCtaButton: FC<Props> = ({ cta }) => {
	const theme = useTheme();

	const { icon: Icon } = cta;

	return (
		<Button
			variant={cta.variant ?? "primary"}
			fullWidth
			startIcon={Icon && <Icon size={theme.iconSize.md} />}
			disabled={cta.disabled}
			onClick={cta.onClick}
		>
			{cta.label}
		</Button>
	);
};
